import { render, staticRenderFns } from "./EditStudentAllowance.vue?vue&type=template&id=c3b15144&scoped=true&"
import script from "./EditStudentAllowance.vue?vue&type=script&lang=js&"
export * from "./EditStudentAllowance.vue?vue&type=script&lang=js&"
import style0 from "./EditStudentAllowance.vue?vue&type=style&index=0&id=c3b15144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b15144",
  null
  
)

export default component.exports